module.exports = __webpack_public_path__ + "img/Retail11.761750b1.png";